import { Col, Image, Row } from "react-bootstrap";
import { useState, useEffect, useRef } from 'react'
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import userImg from '../../../../../assets/user.png'

export default function Presenter({ item, isPlaying, setIsPlaying, handleStop, time, setTime, getMeeting }) {
  const { user: authUser } = useSelector(x => x.auth)
  const url = process.env.REACT_APP_URL
  const meetingId = useParams().meetingId

  const dropdownRef = useRef(null); // Create a ref for the dropdown container

  const [showDropdown, setShowDropdown] = useState(false); // State to toggle dropdown visibility
  const [presenters, setPresenters] = useState({ officersAndMembers: [], guests: [] })
  const [selectedPresenterId, setSelectedPresenterId] = useState('')

  const getPresenters = async () => {
    const response = await fetch(`${url}/users`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authUser.token}`
      }
    })
    if (response.status === 200) {
      const presenters = await response.json()
      // Group presenters by role
      const officersAndMembers = presenters.filter(p => p.acl === 'Officer' || p.acl === 'Member').sort((a, b) => a.firstName.localeCompare(b.firstName))
      const guests = presenters.filter(p => p.acl === 'Guest').sort((a, b) => a.firstName.localeCompare(b.firstName))
      setPresenters({ officersAndMembers, guests })
    }
    else {
      console.log(response)
    }
  }

  const presenterOptions = [
    {
      label: 'Members',
      options: presenters.officersAndMembers.map(presenter => ({ value: presenter._id, label: `${presenter.firstName} ${presenter.lastName}` }))
    },
    {
      label: 'Guests',
      options: presenters.guests.map(presenter => ({ value: presenter._id, label: `${presenter.firstName} ${presenter.lastName}` }))
    }
  ]

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
    if (!showDropdown) {
      getPresenters(); // Fetch users when the dropdown is opened
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDropdown && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        toggleDropdown(); // Close the dropdown if clicked outside
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line
  }, [showDropdown]); // Re-run the effect when showDropdown changes

  const handleUserChange = async (selectedOption) => {
    let wasPlaying = isPlaying;
    let lastTime = time; // Save the current timer value
    // console.log(`LastTime: ${lastTime}, wasPlaying: ${wasPlaying}`)

    if (wasPlaying) {
      await handleStop();
    }
    try {
      if (item.roleAssignmentId === undefined || item.roleAssignmentId === null) {
        // Role assignment does not exist, create it
        const createResponse = await fetch(`${url}/roleAssignment/${meetingId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authUser.token}`,
          },
          body: JSON.stringify({
            role: item.meetingRole._id,
            user: selectedOption.value,
          }),
        });
        // Check if the role assignment exists
        if (createResponse.status === 201 || createResponse.status === 200) {
          // toast.success('Role assignment created successfully', { position: 'bottom-left' });
          // Update the assigned user details in the item object
          const updatedUser = presenters.officersAndMembers
            .concat(presenters.guests)
            .find(user => user._id === selectedOption.value);

          if (updatedUser) {
            item.assignedUser = {
              avatar: updatedUser.avatar || null,
              firstName: updatedUser.firstName,
              lastName: updatedUser.lastName,
            };
          }
          setSelectedPresenterId(selectedOption);
          setShowDropdown(false); // Hide the dropdown after selection
        } else {
          throw new Error('Failed to create role assignment');
        }
      }
      else {
        const roleAssignmentResponse = await fetch(`${url}/roleAssignment/${item.roleAssignmentId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        if (roleAssignmentResponse.status === 200) {
          // Role assignment exists, update it
          const updateResponse = await fetch(`${url}/roleAssignment/${item.roleAssignmentId}`, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${authUser.token}`,
            },
            body: JSON.stringify({
              user: selectedOption.value,
            }),
          });

          if (updateResponse.status === 200) {
            // Update the assigned user details in the item object
            const updatedUser = presenters.officersAndMembers
              .concat(presenters.guests)
              .find(user => user._id === selectedOption.value);

            if (updatedUser) {
              item.assignedUser = {
                avatar: updatedUser.avatar || null,
                firstName: updatedUser.firstName,
                lastName: updatedUser.lastName,
              };
            }

            // toast.success('User assignment updated', { position: 'bottom-left' });
            setSelectedPresenterId(selectedOption);
            setShowDropdown(false); // Hide the dropdown after selection
          } else {
            throw new Error('Failed to update user assignment');
          }
        } else {
          throw new Error('Unexpected response while checking role assignment');
        }
      }

    } catch (err) {
      toast.error('' + err, { position: 'bottom-left' });
    }
    await getMeeting()
    if (wasPlaying) {

      // If the new user has no timer, set it to lastTime
      if (!item.timer || item.timer.time === 0) {
        setTime(lastTime);
      } else {
        setTime(item.timer.time);
      }
      // setIsPlaying(false);
      setTimeout(() => setIsPlaying(true), 0);
    }
  };

  // Custom styles for the Select component
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#343a40',
      color: '#fff',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#343a40',
      color: '#fff',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#495057' : state.isFocused ? '#495057' : '#343a40',
      color: '#fff',
    }),
    input: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#6c757d',
    }),
  }

  return (
    <Col xs={12} lg={6}>
      <Row>
        <Col xs={12}>
          <Row className='avatar justify-content-center'>
            <Col className='hexagon'>
              {!item?.assignedUser?.avatar
                ? <Image src={userImg} style={{ height: '85%', width: '90%' }} />
                : <Image src={'data:image/png;base64,' + item?.assignedUser.avatar} />
              }
            </Col>
          </Row>
        </Col>
        <Col>
          <Row>
            <Col>
              {authUser?.user.acl === "Officer" ?
                <h1 onClick={toggleDropdown} style={{ cursor: 'pointer' }}>
                  {item?.assignedUser?.firstName.toUpperCase() || 'TBA'}
                </h1>
                :
                <h1>
                  {item?.assignedUser?.firstName.toUpperCase() || 'TBA'}
                </h1>
              }
              {authUser?.user.acl === "Officer" ? (
                <h5
                  onClick={toggleDropdown} style={{ cursor: 'pointer' }}
                >
                  {item?.assignedUser?.lastName.toUpperCase() || 'TBA'}
                </h5>
              ) : (
                <h5>
                  {item?.assignedUser?.lastName.toUpperCase() || 'TBA'}
                </h5>
              )}
              <p></p>
              {showDropdown && (
                <div ref={dropdownRef}>
                  <Select
                    options={presenterOptions}
                    className='mb-3 formInput'
                    name='presenter'
                    value={presenterOptions.flatMap(group => group.options).find(option => option.value === selectedPresenterId) || ''}
                    onChange={handleUserChange}
                    isClearable
                    isSearchable
                    styles={customStyles}
                    placeholder='Select a presenter'
                    menuPlacement="top"
                  />
                </div>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
}